// console.log("window.location", window.location.hostname);
const hostname = window.location.hostname;
export default {
    fileServe: import.meta.env.VITE_APP_BASE_API,
    webSocketServe: import.meta.env.VITE_APP_ENV === 'production' ? `ws://${hostname}/klyun` : `ws://${hostname}:8080`,
    mqttWsServe: import.meta.env.VITE_APP_MQTT_WS_API,
}

